import { SubNavLink as UnionSubNavLink } from '@xo-union/tk-ui-sub-nav';
import { compose } from '@xo-union/react-css-modules';
import React from 'react';

import styles from './subNav.scss';

interface Props {
  active: boolean;
  index: number;
  name: string;
  onClickHandler: (arg0: number) => void;
}

// overrides the union styles
const classes = compose({
  link: styles.link,
  'list-item': styles.listItem,
  active: styles.active,
});

export const SubNavLink: React.FC<Props> = ({ active, index, name, onClickHandler }) => {
  return (
    <UnionSubNavLink
      classes={classes}
      key={`sub-nav-link-${index}`}
      active={active}
      onClick={(): void => onClickHandler(index)}
    >
      <div data-testid={`sub-nav-link-${index}`}>{name}</div>
    </UnionSubNavLink>
  );
};
